import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class DmcPackageHelperService {

  
  dmcPackageFormDefaultValues:any = null;

  constructor() { }

  private readonly storageKey = 'dmcPackageFormDefaultValues';

  setDmcPackageFormDefaultValues(defaultValues:any) {
    this.dmcPackageFormDefaultValues = defaultValues;
    try {
      localStorage.setItem(this.storageKey, JSON.stringify(defaultValues));
    } catch (e) {
      console.warn('Unable to save package defaults to localStorage', e);
    }
  }

  getDmcPackageFormDefaultValues() {
    if (this.dmcPackageFormDefaultValues) {
      return this.dmcPackageFormDefaultValues;
    }
    try {
      const stored = localStorage.getItem(this.storageKey);
      if (stored) {
        this.dmcPackageFormDefaultValues = JSON.parse(stored);
      }
    } catch (e) {
      console.warn('Unable to read package defaults from localStorage', e);
    }
    return this.dmcPackageFormDefaultValues;
  }
}
